import GLightbox from 'glightbox'
import Swiper, {
    Navigation,
    Autoplay,
    Pagination,
    EffectFade,
    Lazy
} from "swiper";

const gallery = document.querySelectorAll('[data-gallery]');
const slider = document.querySelectorAll('[data-swiper]');

const lightbox = GLightbox({
    selector: '[data-gallery] a'
});

slider.forEach(element => {
    const swiper = new Swiper(element, {
        modules: [Navigation, Autoplay, Pagination, Lazy, EffectFade],
        loop: true,
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 20,
        slidesPerView: "auto",
        effect: "fade",
        autoplay: {
            disableOnInteraction: false,
            delay: 8000,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        lazy: true,
    });
});
